import { styled } from '../../../stitches.config';

export const Flex = styled('div', {
  display: 'flex',
});
